 
import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
/**
 * Custom Date Adapter for month/year format
 */
@Injectable()
export class MonthYearDateAdapter extends NativeDateAdapter {
  // override format(date: Date, displayFormat: Object): string {
  override format(date: Date, _displayFormat: object): string {
    if (date) {
      const month = date.getMonth() + 1;
      const monthString = month < 10 ? '0' + month : month.toString();
      const year = date.getFullYear();
      return `${monthString}/${year}`;
    }
    return '';
  }
}

export const LT_MONTH_YEAR_FORMATS = {
  parse: {
    dateInput: {month: 'numeric', year: 'numeric'},
  },
  display: {
    dateInput: 'MM/yyyy',
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM yyyy',
  },
};
